/*
 * @Author: jerryfwang
 * @Date: 2018-06-08 17:29:08
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-12-22 20:02:11
 */
import _ from 'lodash';
import querystring from 'query-string';
import { isIOS } from '@tencent/qb-article-util/lib/UA';
import Qua from '@tencent/parse-qua';
import { userCenterUrl } from '@tencent/qb-article-util/lib/urlHelper';
import cookies from 'js-cookie';
import url from './url';
import { isQbInfoApp, isHippy, postMessage } from '../utility';
type Params = {
  userId: string,
  accountType: number,
  platform?: number,
  qbVersion?: number,
  docId: string,
};
const getImageExtData = (imgExternalData: Object) => {
  let isQb = false;
  if (typeof window !== 'undefined' && window.navigator) {
    isQb = isQbInfoApp(window.navigator.userAgent);
  }
  if (!isQb) {
    return {};
  }
  const version = _.get(window, 'browser.env.version');
  if (version < 90) {
    return {};
  }
  if (imgExternalData) {
    if (imgExternalData['1']) {
      // 智能识图约定key
      const extDataStr = imgExternalData['1'];
      try {
        const { sText = '', sBuParam = '' } = JSON.parse(extDataStr) || {};
        return { sText, sBuParam };
      } catch (e) {
        console.log(e);
      }
    }
  }
  return {};
};
const findAllImages = (contentFields) => {
  const imageMap = {};
  if (typeof contentFields !== 'object') {
    const all = [];
    [].slice.call(document.getElementsByTagName('img')).forEach((img) => {
      if (img.src && img.width >= 200) {
        all.push(img.src);
      }
    });
    return { all, imageMap: {} };
  }
  const all = contentFields
    .filter((item) => item.type === 'image')
    .map((item: Object) => {
      let { src } = item;
      // if (item.bIsCommerce) {
      try {
        if (item && item.extInfo) {
          const originUrl = url.parse(item.extInfo, true).query.imageUrl || '';
          if (originUrl) {
            imageMap[originUrl] = src;
          }
        }
        const urlObj = url.parse(src, true);
        if (item && item.imgExternalData) {
          const { sBuParam } = getImageExtData(item.imgExternalData);
          if (sBuParam) {
            urlObj.query.sBuParam = sBuParam;
          }
          src = url.format(urlObj);
        }
      } catch (e) {
        console.log('findAllImages', e);
      }
      // }
      return src;
    });
  if (typeof window !== 'undefined' && !window._nativeGetNewsAllImages) {
    window._nativeGetNewsAllImages = () =>
      JSON.stringify({
        allImages: all,
        from: 2,
        fromUrl: window.location.href,
      });
  }
  return {
    all,
    imageMap,
  };
};
const getPersonalUrl = function (params: Params) {
  if (typeof window === 'undefined') {
    return;
  }
  const queryObj = querystring.parse(window.location.href);
  const { extenddata = '', ch } = queryObj || {};
  const extData = querystring.parse(extenddata) || {};
  const { docId, pid, queryId } = Object.assign(queryObj, extData);
  const qua = cookies.get('qb_qua');
  const quaObj = qua ? new Qua(qua) : {};
  const isSogou = /Sogou/gi.test(navigator.userAgent);
  const pars = Object.assign(params, {
    qbVersion: isSogou ? 100 : quaObj.version,
    platform: quaObj.platForm === 'ADR' ? 1 : 2,
    env: window.location.href.indexOf('sparta') > -1 ? 'test' : '',
    ext: {
      scene: 1,
      productId: pid,
      itemId: docId,
      queryId,
      innerch: `${ch ? `${ch}_` : ''}1301`,
    },
  });
  const url = userCenterUrl && `${userCenterUrl(pars)}&contentid=${params.docId}&contenttype=1`;
  return url;
};
/**
 * 正文广告IOS预缓存
 */
const adPreloadFnc = (backupUrls?: Array<string> = []) => {
  const ua = window.navigator.userAgent || '';
  const version = _.get(window, 'browser.env.version');
  // const alertFnc = _.get(window, 'browser.app.toast');
  if (typeof window !== 'undefined' && isIOS(ua) && version >= 90 && backupUrls && backupUrls.length) {
    // alertFnc && alertFnc(`缓存地址:${JSON.stringify(backupUrls)}`);
    isHippy() &&
      postMessage(
        JSON.stringify({
          func: 'coolread.adPreload',
          data: { preloadUrls: backupUrls },
        }),
      );
  } /* else if (!backupUrls || !backupUrls.length) {
    // alertFnc && alertFnc('缓存url为空，请查后端');
  } else if (!isIOS(ua) || version < 90) {
    // alertFnc && alertFnc('终端版本不对，请查终端');
  } else {
    // alertFnc && alertFnc('其他问题,请联系前端');
  } */
};
export { findAllImages, getPersonalUrl, getImageExtData, adPreloadFnc };
